import { render, staticRenderFns } from "./InstructionsVarDescription.vue?vue&type=template&id=a687b9c0&"
import script from "./InstructionsVarDescription.vue?vue&type=script&lang=js&"
export * from "./InstructionsVarDescription.vue?vue&type=script&lang=js&"
import style0 from "./InstructionsVarDescription.vue?vue&type=style&index=0&id=a687b9c0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports